import { Settings, Sliders, Users, UserPlus, ChevronsUp, DollarSign,
    //  BarChart2,
    Grid,
 } from 'react-feather';

const pagesSection = [
  {
    href: '/salesperson/dashboard',
    title: 'Dashboard',
    icon: Sliders,
    children: [
      {
        href: '/salesperson/dashboard/default',
        title: 'Default',
      },
      {
        href: '/salesperson/dashboard/sales',
        title: 'Sälj',
      },
      {
        href: '/salesperson/dashboard/ranking',
        title: 'Ranking',
      },
      {
        href: '/salesperson/dashboard/user-statistics',
        title: 'User statistics',
      },
    ],
  },
  // Temporarily hidden until backend team completes their update
  // {
  //   href: 'statistik',
  //   title: 'Statistik',
  //   icon: BarChart2,
  //   children: [
  //     {
  //       href: '/salesperson/statistik/landningsida',
  //       title: 'Landningsida',
  //     },
  //     {
  //       href: '/salesperson/statistik/hemsida',
  //       title: 'Hemsida',
  //     },
  //   ],
  // },
  {
    href: 'produkter',
    title: 'Produkter',
    icon: Grid,
    children: [
      {
        href: '/salesperson/sites',
        title: 'Landningssidor',
      },
      {
        href: '/salesperson/hemsidor',
        title: 'Hemsidor',
      },
    ],
  },
  {
    href: 'client',
    title: 'Inlogg kunder',
    icon: Users,
  },
  {
    href: 'kundföretag',
    title: 'Kundföretag',
    icon: Users,
  },
  {
    href: 'leads',
    title: 'Kundförfrågningar',
    icon: UserPlus,
  },
  {
    href: 'settings',
    title: 'Inställningar',
    icon: Settings,
  },
  {
    href: 'users',
    title: 'Användare',
    icon: Users,
  },
  {
    href: 'proposal',
    title: 'Proposals',
    icon: ChevronsUp,
  },
  { href: 'invoices', title: 'Fakturor', icon: DollarSign },
];

const navItems = [
  {
    title: '',
    pages: pagesSection,
  },
];

export default navItems;
